const TEST_IDS = {
    header: {
        uploadSRTReply: 'header-button-upload-srt-reply',
        generateFiles: 'header-button-generate-files'
    },
    errorsInfo: 'srt-files-generation-errorsInfo',
    table: {
        id: 'srt-files-generation-table',
        actions: {
            editPresentation: 'table-actions-editPresentation',
            seePresentation: 'table-actions-seePresentation',
            downloadPresentationPDF: 'table-actions-downloadPresentationPDF'
        },
        visits: {
            id: 'vists-srt-files-generation-table',
            actions: {
                downloadVisitReport: 'visits-table-actions-downloadVisitReport',
                seeVisit: 'visits-table-actions-seeVisit',
                editVisit: 'visits-table-actions-editVisit'
            }
        }
    },
    extraFilters: {
        rgrl: {
            contract: 'rgrl-filter-contract',
            establishment: 'rgrl-filter-establishment',
            stateSRT: 'rgrl-filter-stateSRT',
            startDate: 'rgrl-filter-startDate',
            fechaFin: 'rgrl-filter-endDate'
        },
        visits: {
            contract: 'visits-filter-contract',
            establishment: 'visits-ilter-establishment',
            stateSRT: 'visits-filter-stateSRT',
            visitType: 'visits-filter-visitType'
        }
    },
    drawers: {
        generateFiles: {
            infoAlert: 'drawer-generateFiles-infoAlert',
            buttons: {
                cancel: 'drawer-generateFiles-button-cancel',
                submit: 'drawer-generateFiles-button-submit'
            }
        },
        uploadResponse: {
            text: {
                fileName: 'drawer-uploadResponse-fileName',
                allowedFiles: 'drawer-uploadResponse-allowedFiles'
            },
            inputs: {
                file: 'drawer-uploadResponse-input-file'
            },
            buttons: {
                cancel: 'drawer-uploadResponse-button-cancel',
                submit: 'drawer-uploadResponse-button-submit'
            }
        }
    }
};


export {TEST_IDS}